import * as React from 'react'

function SvgAn(props) {
	return (
		<svg viewBox="-27 -14 54 36" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M-27-14h54v36h-54z" />
			<path fill="#dc171d" d="M-6-14H6v36H-6z" />
			<path fill="#012a87" d="M-27-2h54v12h-54z" />
			<g id="an_svg__c" fill="#fff" transform="scale(1.5)">
				<g id="an_svg__b">
					<path id="an_svg__a" transform="rotate(18 3.157 -.5)" d="M0 0v1h.5z" />
					<use xlinkHref="#an_svg__a" transform="scale(-1 1)" />
				</g>
				<use xlinkHref="#an_svg__b" transform="rotate(72)" />
				<use xlinkHref="#an_svg__b" transform="rotate(-72)" />
				<use xlinkHref="#an_svg__b" transform="rotate(144)" />
				<use xlinkHref="#an_svg__b" transform="rotate(-144)" />
			</g>
			<g id="an_svg__d">
				<use xlinkHref="#an_svg__c" transform="translate(8 3.314)" />
				<use xlinkHref="#an_svg__c" transform="translate(3.314 8)" />
			</g>
			<use xlinkHref="#an_svg__d" transform="scale(-1 1)" />
		</svg>
	)
}

export default SvgAn
